/* Souvy productembeds in blogs (vervangt Dead Simple Product Embed). */
(() => {
  if (window.__souvyEmbeds) return;
  window.__souvyEmbeds = true;

  const LABEL_ADD = 'In winkelwagen';
  const LABEL_ADDED = 'Toegevoegd';
  const LABEL_SOLDOUT = 'Uitverkocht';
  const CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Variantkeuze: prijs, knop en voorraad bijwerken
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches || !input.matches('[data-spe-card] input[type="radio"]')) return;
    const card = input.closest('[data-spe-card]');
    const button = card.querySelector('[data-spe-add]');
    const available = input.dataset.available === 'true';

    card.querySelector('[data-spe-price]').textContent = input.dataset.price;
    card.querySelector('[data-spe-compare]').textContent = input.dataset.compare || '';
    card.querySelector('[data-spe-stock]').hidden = !available;
    card.querySelector('[data-spe-error]').hidden = true;

    button.dataset.variantId = input.value;
    button.disabled = !available;
    button.classList.remove('is-added');
    button.querySelector('[data-spe-label]').textContent = available ? LABEL_ADD : LABEL_SOLDOUT;
  });

  // Toevoegen aan winkelwagen, op dezelfde manier als het Impact-productformulier
  document.addEventListener('click', async (event) => {
    const button = event.target.closest && event.target.closest('.spe [data-spe-add]');
    if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();

    const container = button.closest('.spe');
    const errorEl = container.querySelector('[data-spe-error]');
    const ids = (button.dataset.variantIds || button.dataset.variantId || '').split(',').filter(Boolean);
    if (!ids.length) return;

    const sections = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));

    const formData = new FormData();
    ids.forEach((id, index) => {
      formData.append(`items[${index}][id]`, id);
      formData.append(`items[${index}][quantity]`, '1');
    });
    formData.set('sections', sections.join(','));
    formData.set('sections_url', `${root}variants/${ids[0]}`);

    button.setAttribute('aria-busy', 'true');
    if (errorEl) errorEl.hidden = true;

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const json = await response.json();

      if (!response.ok) {
        if (errorEl) {
          errorEl.textContent = json.description || json.message || 'Toevoegen is niet gelukt. Probeer het opnieuw.';
          errorEl.hidden = false;
        }
        return;
      }

      const settings = (window.themeVariables && window.themeVariables.settings) || {};
      if (settings.cartType === 'page') {
        window.location.href = `${root}cart`;
        return;
      }

      const cart = await (await fetch(`${root}cart.js`)).json();
      cart.sections = json.sections;

      button.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items: json.items || [json], cart }
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart }
      }));

      const label = button.querySelector('[data-spe-label]');
      const original = label.textContent;
      button.classList.add('is-added');
      label.innerHTML = CHECK + LABEL_ADDED;
      label.style.display = 'inline-flex';
      label.style.alignItems = 'center';
      label.style.gap = '8px';
      setTimeout(() => {
        button.classList.remove('is-added');
        label.textContent = original;
      }, 2500);
    } catch (error) {
      if (errorEl) {
        errorEl.textContent = 'Toevoegen is niet gelukt. Controleer je verbinding en probeer het opnieuw.';
        errorEl.hidden = false;
      }
    } finally {
      button.removeAttribute('aria-busy');
    }
  });
})();
